import { HugeiconsIcon } from '@hugeicons/react'
import { Cancel01Icon, Location01Icon, SunriseIcon, Building03Icon } from '@hugeicons/core-free-icons'

import { useAppStore } from '@/store'

// Project info as a proper takeover, not a dock panel: this is the one surface
// that sells the place, so it gets the hero treatment. The hero is Diriyah's
// own campaign image (their og:image, vendored to public/img/ — the CDN is not
// CORS-open and a marketing page URL is not a stable dependency).
export function ProjectInfoModal() {
  const tool = useAppStore((s) => s.tool)
  const closeTool = useAppStore((s) => s.closeTool)
  const setRegisterOpen = useAppStore((s) => s.setRegisterOpen)

  if (tool !== 'info') return null

  return (
    <div className="fixed inset-0 z-100 flex items-center justify-center p-4 sm:p-8">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={closeTool} />

      <div className="glass light-surface relative flex max-h-full w-full max-w-xl flex-col overflow-hidden p-0">
        {/* Hero */}
        <div className="relative aspect-16/9 w-full shrink-0">
          <img
            src="/img/diriyah-hero.webp"
            alt="At-Turaif, Diriyah"
            className="absolute inset-0 size-full object-cover"
          />
          <div className="absolute inset-0 bg-linear-to-t from-black/75 via-black/10 to-transparent" />
          <button
            type="button"
            onClick={closeTool}
            aria-label="Close"
            className="glass-pill absolute top-3 right-3 flex size-9 cursor-pointer items-center justify-center text-white"
          >
            <HugeiconsIcon icon={Cancel01Icon} size={16} strokeWidth={2} />
          </button>
          <div className="absolute right-5 bottom-4 left-5">
            <p className="text-[11px] font-semibold tracking-[0.14em] text-white/70 uppercase">
              Diriyah · Riyadh
            </p>
            <h2 className="font-serif text-3xl text-white">The City of Earth</h2>
          </div>
        </div>

        {/* Body */}
        <div className="flex min-h-0 flex-col gap-5 overflow-y-auto p-5 sm:p-6">
          <p className="text-muted-foreground text-sm leading-relaxed">
            A residential quarter beside At-Turaif, the UNESCO-listed birthplace of the
            Saudi state. Shown on its real site: photorealistic terrain, live sun
            position for Riyadh, and every residence in its true orientation.
          </p>

          <div className="grid grid-cols-3 gap-3">
            {[
              { icon: Building03Icon, value: '3', label: 'Residence types' },
              { icon: Location01Icon, value: '420 m', label: 'Site span' },
              { icon: SunriseIcon, value: 'Live', label: 'Riyadh sun' },
            ].map((s) => (
              <div key={s.label} className="bg-foreground/4 rounded-xl px-3 py-3 text-center">
                <HugeiconsIcon
                  icon={s.icon}
                  size={17}
                  strokeWidth={2}
                  className="text-primary mx-auto"
                />
                <p className="mt-1.5 font-serif text-lg leading-none tabular-nums">{s.value}</p>
                <p className="text-muted-foreground mt-1 text-[11px]">{s.label}</p>
              </div>
            ))}
          </div>

          <div className="flex items-center justify-between gap-3">
            <p className="text-muted-foreground text-xs">
              Walk the quarter, filter residences, or step inside the interiors from the
              dock below.
            </p>
            <button
              type="button"
              onClick={() => {
                closeTool()
                setRegisterOpen(true)
              }}
              className="bg-primary text-primary-foreground rounded-control shrink-0 cursor-pointer px-4 py-2.5 text-sm font-semibold transition-opacity hover:opacity-90"
            >
              Register interest
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
